import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Business from "./Pages/Business";
import TermsOfUse from "./Pages/TermsOfUse";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import CancellationPolicy from "./Pages/CancellationPolicy";
import AccountDeletion from "./Pages/AccountDeletion";
import Support from "./Pages/Support";
import ErrorPage from "./Pages/ErrorPage";
import EventShareFallback from "./Pages/EventShareFallback";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";

const App = () => {
  const { i18n } = useTranslation();
  // Check if the current language direction is RTL
  const isRTL = i18n.dir() === "rtl";
  return (
    <Router>
      <ToastContainer
        theme="dark"
        progressClassName="toastProgress"
        position="top-center"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={isRTL}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        closeButton={false}
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/business" element={<Business />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />
        <Route path="/support" element={<Support />} />
        <Route path="/event/:eventId" element={<EventShareFallback />} />
        <Route path="/event/:eventId/details" element={<EventShareFallback />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
};

export default App;
